import { render, staticRenderFns } from "./StagesFormations.vue?vue&type=template&id=5b5f2a9c&"
import script from "./StagesFormations.vue?vue&type=script&lang=js&"
export * from "./StagesFormations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports